import React from 'react';
import { BannerAlertVariant, Icon } from '@amzn/storm-ui';
import { BANNER_TYPE, LocalNotification } from '@amzn/aac-chrome-internal-api';
import { bannerIconMap } from '../types';
import { ConnectedBannerContent } from 'src/commons/components/ConsolidatedBanner/BannerContent';
import { BANNER_LEVEL } from 'src/app/slice';
import { BannerText } from '../styles';
import { BannerShell } from '../Common/BannerShell';

interface SingleBannerProps {
  banner: LocalNotification;
  onDismissClick: (dismissBanner: LocalNotification) => void;
  bannerLevel: BANNER_LEVEL;
  isRenderedInModal?: boolean;
}

export const SingleBanner: React.VFC<SingleBannerProps> = ({
  banner,
  onDismissClick,
  bannerLevel,
  isRenderedInModal = true,
}) => {
  const isConsoleLevel = bannerLevel === BANNER_LEVEL.CONSOLE;

  return (
    <BannerShell
      dataTestId="single-banner"
      bannerLevel={bannerLevel}
      variant={banner.type.toLowerCase() as BannerAlertVariant}
      withCloseButton={banner.type !== BANNER_TYPE.ERROR}
      onClose={() => onDismissClick(banner)}
      header={banner.title}
    >
      <BannerText>
        {isConsoleLevel && isRenderedInModal && (
          <Icon type={bannerIconMap[banner.type]} />
        )}
        <ConnectedBannerContent
          banner={banner}
          bannerLevel={bannerLevel}
          isRenderedInModal={isRenderedInModal}
        />
      </BannerText>
    </BannerShell>
  );
};
